<template>

  <validation-observer
    #default="{ invalid }"
  >
    <b-form-group
      v-for="item of sorted"
      :key="item.name"
      :label-for="item.name"
      :label="item.isRequired ? `${item.name} *`: `${item.name}`"
    >

      <small class="text-primary"> {{ item.description }} </small>
      <validation-provider
        #default="{ errors }"
        :name="item.name"
        :rules="`pdf|${item.isRequired ? 'required' : ''}`"
      >
        <b-row>
          <b-col md="9">

            <b-form-file
              :id="item.name"
              v-model="files[item.name]"
              :state="errors.length > 0 ? false : null"
              placeholder="Arraste ou selecione um arquivo"
              drop-placeholder="Arraste o arquivo aqui."
              browse-text="Procurar"
            />
          </b-col>

          <b-col md="3">
            <b-button
              v-if="!item.number"
              variant="primary"
              @click="addFile(item.name)"
            >
              Adicionar + 1
            </b-button>

            <b-button
              v-else
              variant="danger"
              @click="removeFile(item.name)"
            >
              Remover
            </b-button>
          </b-col>

        </b-row>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <b-button
      variant="primary"
      style="width: 100%"
      :disabled="invalid"
      @click="() => $emit('upload-file')"
    >
      Enviar
    </b-button>
  </validation-observer>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormFile, BButton,
} from 'bootstrap-vue'

import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormGroup,
  },
  props: {
    files: {
      type: Object,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      items1: [],
    }
  },

  computed: {
    sorted() {
      const { items1 } = this
      return items1.sort((item1, item2) => item1.name.localeCompare(item2.name))
    },
  },

  created() {
    const { items } = this
    this.items1 = JSON.parse(JSON.stringify(items))
  },

  methods: {

    addFile(file) {
      const { items1 } = this
      const filteredByFileName = items1.filter(item => item.name.includes(file))

      const newItemNumber = filteredByFileName.length + 1
      const newItem = {
        ...filteredByFileName[filteredByFileName.length - 1],
        name: `${file} ${newItemNumber}`,
        number: newItemNumber,
      }

      this.items1.push(newItem)
    },

    removeFile(file) {
      const index = this.items1.findIndex(item => file === item.name)
      this.items1.splice(index, 1)
    },
  },
}
</script>
